"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestUserProfileManagementResult = void 0;
var GuestUserProfileManagementResult;
(function (GuestUserProfileManagementResult) {
    GuestUserProfileManagementResult["nameUpdated"] = "nameUpdated";
    GuestUserProfileManagementResult["phoneNumberUpdated"] = "phoneNumberUpdated";
    GuestUserProfileManagementResult["profilePictureUpdated"] = "profilePictureUpdated";
})(GuestUserProfileManagementResult || (exports.GuestUserProfileManagementResult = GuestUserProfileManagementResult = {}));
//# sourceMappingURL=GuestUserProfileManagementResult.js.map